import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export const UrgencySection = () => {
  const {
    formatted,
    barPct
  } = useCountdown();
  return <section className="py-4 md:py-8 bg-bttf-bg relative overflow-hidden" id="cta" data-id="element-581">
      <div className="container mx-auto px-4 relative z-10 max-w-2xl" data-id="element-582">
        <div className="border border-bttf-primary/40 rounded-xl p-6 md:p-8 bg-bttf-bg/60 backdrop-blur-sm shadow-[0_0_30px_rgba(255,108,0,0.2)]" data-id="element-583">
          {/* Title */}
          <h2 className="text-xl md:text-2xl font-bold font-future text-bttf-text text-center tracking-widest uppercase mb-2" data-id="element-584">
            DON'T LET THIS MOMENT PASS
          </h2>
          <p className="text-bttf-subtext font-body text-center text-sm mb-6" data-id="element-585">
            This price disappears when the timer hits zero.
          </p>

          {/* Countdown bar */}
          <div className="mb-6" data-id="element-586">
            <div className="relative h-6 bg-gray-800 rounded-full overflow-hidden border border-bttf-subtext/20" data-id="element-587">
              <div className="h-full bg-gradient-to-r from-red-600 to-red-500 rounded-full transition-all duration-1000 ease-linear" style={{
              width: `${barPct}%`
            }} data-id="element-588"></div>
              <span className="absolute inset-0 flex items-center justify-center text-[11px] font-bold text-white font-body tabular-nums" data-id="element-589">
                {formatted} remaining
              </span>
            </div>
            <p className="text-center text-xs text-bttf-subtext font-body mt-1.5" data-id="element-590">
              Price resets when timer expires
            </p>
          </div>

          {/* Copy */}
          <div className="text-center mb-6" data-id="element-591">
            <p className="text-lg font-semibold text-bttf-text font-body mb-1" data-id="element-592">
              True fans don't wait.
            </p>
            <p className="text-lg font-semibold text-bttf-text font-body mb-1" data-id="element-593">
              Casuals do.
            </p>
            <p className="text-xl font-bold text-bttf-primary font-future mt-2" data-id="element-594">
              Which one are you?
            </p>
          </div>

          {/* CTA */}
          <a href="#pricing-top" className="block w-full text-center bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text font-bold py-4 rounded-md text-base md:text-lg transition-all transform hover:scale-[1.02] shadow-md hover:shadow-neon-orange font-body uppercase tracking-wide" data-id="element-595">
            CLAIM YOUR COLLECTOR'S EDITION
          </a>
        </div>
      </div>
    </section>;
};